import { IPaymentMethod } from "@features/summary/interface/IPaymentMethod";

export interface IPaymentMethodResponse {
    cardholderName: string;
    isDefault: boolean;
    expirationDate: string;
    partialDigits: string;
    paymentMethodId: number;
    type: string;
    providerReference: string;
}

export const getResponseToState = (response: IPaymentMethodResponse[]): IPaymentMethod[] =>
    response.map((paymentMethod) => ({
        cardholderName: paymentMethod.cardholderName,
        isDefault: paymentMethod.isDefault,
        expirationDate: paymentMethod.expirationDate,
        partialDigits: paymentMethod.partialDigits,
        paymentMethodId: paymentMethod.paymentMethodId,
        type: paymentMethod.type,
        providerReference: paymentMethod.providerReference,
    }));
